<template>
  <div class="group-index-item">
    <div class="group-index-title">
      <div class="left">{{navTitle}}</div>
      <div class="right" @click="jumpDetails">
        查看更多
        <img src="@/assets/image/arrow_icon@2x.png" alt />
      </div>
    </div>
    <div class="group-index-info">
      <div>
        <p>{{formData.level1Count}}</p>
        <p class="one">一级预警</p>
      </div>
      <div>
        <p>{{formData.level2Count}}</p>
        <p class="two">二级级预警</p>
      </div>
      <div>
        <p>{{formData.level3Count}}</p>
        <p class="three">三级预警</p>
      </div>
    </div>
  </div>
</template>
<script>
import utils from "@/utils/common";
export default {
  data() {
    return {};
  },
  props: {
    navTitle: {
      default: "待处理预警工单",
      type: String,
    },
    formData: {
      default: function () {
        return {};
      },
      type: Object,
    },
  },
  methods: {
    jumpDetails() {
      if (this.formData.beeId) {
        this.$router.push({
          path:'/groupwarningbeesdetails',
          query:{beeId:this.formData.beeId}
        })
        //  utils.jumpToNewPage({
        //   url: window.location.origin + "/h5user/groupwarningbeesdetails?beeId="+this.formData.beeId,
        //   noTitle: "1",
        // });
      } else {
         this.$router.push({
          path:'/groupwarningbeeslist'
        })
        // utils.jumpToNewPage({
        //   url: window.location.origin + "/h5user/groupwarningbeeslist",
        //   noTitle: "1",
        // });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.group-index-item {
  background-color: #fff;
  margin: 20px;
  .group-index-title {
    font-size: 24px;
    color: #333;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    height: 79px;
    padding: 0 30px;
    justify-content: space-between;
    align-items: center;
    .left {
      flex: 1;
    }
    .right {
      align-items: center;
      display: flex;
      color: #999;
      text-align: right;
      img {
        width: 44px;
        height: 44px;
        object-fit: cover;
      }
    }
  }
  .group-index-info {
    padding: 0px 30px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 178px;
    div {
      text-align: center;
      font-size: 36px;
      font-weight: 500;
      color: #333;
      .one {
        color: #f8d541;
        font-size: 24px;
        padding: 10px 0;
      }
      .two {
        color: #f8a651;
        font-size: 24px;
        padding: 10px 0;
      }
      .three {
        color: #ed3939;
        font-size: 24px;
        padding: 10px 0;
      }
    }
  }
}
</style>